export default __webpack_public_path__ + "static/media/lgn-lg-2.f3b0cd50.webp";